export const ADMIN_ROLE = 'admin';
export const DEVELOPER_ROLE = 'developer';
export const CREATOR_ROLE = 'creator';
export const PENDING_CREATOR_ROLE = 'pending_creator';

export const ROLES = Object.freeze({
  ADMIN_ROLE,
  DEVELOPER_ROLE,
  CREATOR_ROLE,
  PENDING_CREATOR_ROLE,
});
